import React, { lazy } from "react";
import Loadable from "../components/Loadable";
// import { authRoles } from "../auth/authRoles";
import { routeCheck } from "app/data/roles";

const EquipmentList = Loadable(lazy(() => import('app/views/equipment/list/EquipmentList')));
const EquipmentAuthorizedUsers = Loadable(lazy(() => import('app/views/equipment/authorizedUsers/EquipmentUsersList')))

const equipmentPaths = routeCheck(
  [
    { path: "/equipments/list", element: <EquipmentList /> },
    { path: "/equipments/authorizedUsers", element: <EquipmentAuthorizedUsers /> }
  ],
  false
)

export default equipmentPaths;